"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.APP_PATHS = void 0;
exports.APP_PATHS = [
    'auth',
    'roles',
    'users',
    'shops',
    'orders',
    'products',
    'contracts',
    'deliverymen',
    'customers',
    'clockings-in',
    'printers',
    'advertisements',
    'account-codes',
    'catalogs',
    'options',
    'promotions',
    'packs',
    'catalog-snapshots',
    'tags',
    'taxes',
    'kitchen-areas',
    'catalog-shops',
    'product-variations',
    'catalog-snapshot-to-shops',
    'catalog-to-packs',
    'catalog-to-products',
    'catalog-to-promotions',
    'connectors',
    'ingredients',
    'loyalties',
    'order-cancel-reasons',
    'services',
    'fiscal',
    'delivery-zones',
    'payment-methods',
    'payment-providers',
    'steps',
    'variations',
    'organizations',
    'shops',
    'users',
    'timesheets',
    'delivery-app',
    'suppliers',
    'supplier-articles',
    'ingredient-mappings',
    'recipes',
    'document-imports',
    'invoices',
    'ai-credits',
    'price-trends',
    'days',
    'search',
    'anomalies',
    'reports',
    'history',
];
